export default {
  pageTitle: 'Relationship History',
  cards: [
    {
      title: 'RelationShip History Details',
      fields: [
        {
          label: 'How did you get referred to Fashion Nova?',
          name: 'referredToFashionNova',
          type: 'text',
          required: true,
        },
        {
          label: 'Have you worked with Fashion Nova under a different name?',
          name: 'workedWithFashionNova',
          type: 'yes_no',
          required: true,
        },
        {
          cond: ({ workedWithFashionNova }) => workedWithFashionNova === 'yes',
          label: 'Provide previous company Name(s)',
          name: 'previousCompanyName',
          type: 'text',
          required: true,
        },
        {
          cond: ({ workedWithFashionNova }) => workedWithFashionNova === 'yes',
          label: 'What caused this business name change?',
          name: 'businessNameChange',
          type: 'text',
          required: true,
        },
        {
          label: 'Have you previously applied to be a vendor at Fashion Nova?',
          name: 'appliedToBeVendor',
          type: 'yes_no',
          required: true,
        },
        {
          cond: ({ appliedToBeVendor }) => appliedToBeVendor === 'yes',
          label: 'Who was your primary point of contact?',
          name: 'primaryPointOfContact',
          type: 'text',
        },
        {
          label:
            'Are you aware of any direct or indirect material relationship between $$entityLegalName$$ (or ' +
            'any of its employees or representatives) and any Fashion Nova employee or director (including ' +
            'their immediate family members)',
          name: 'awareOfAnyDirect',
          type: 'yes_no',
          required: true,
        },
        {
          cond: ({ awareOfAnyDirect }) => awareOfAnyDirect === 'yes',
          label:
            'Please provide background on existing relationship between vendor and Fashion Nova employee/director.',
          name: 'backgroundOnExistingRelationship',
          type: 'text',
          required: true,
        },
        {
          label:
            'Do you or any of your key employees have an employment or family relationship with our direct competitors?',
          name: 'haveEmploymentRelationship',
          type: 'yes_no',
          required: true,
        },
        {
          cond: ({ haveEmploymentRelationship }) =>
            haveEmploymentRelationship === 'yes',
          label: 'Please disclose/describe.',
          name: 'discloseOrDescribe',
          type: 'text',
          required: true,
        },
      ],
    },
  ],
};
